import React, { useState, useEffect, useRef } from "react";
import ReadyInfo from "../../../_components/steps/ReadyInfo";
import ViolationInfo from "../../../_components/steps/ViolationInfo";
import ContactInfo from "../../../_components/steps/ContactInfo";
import VehicleInfo from "../../../_components/steps/VehicleInfos";
import AddressInfo from "../../../_components/steps/AddressInfo";
// import LppInfo from "../../../_components/steps/LppInfo";
import IdInfo from "../../../_components/steps/IdInfo";
import LocationSchedule from "../../../_components/steps/LocationSchedule";
import MyAccount from "../../../_components/steps/MyAccount";
import Box from "@mui/system/Box";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";
import DirectionsWalkIcon from "@mui/icons-material/DirectionsWalk";
import { styled, useTheme } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";
import VerifiedIcon from "@mui/icons-material/Verified";
import { brandColors } from "../../../_components/brandedComponent/BrandedColors";
import Cookies from "universal-cookie";
import { LifeSafer, Monitech } from "../../../_helpers/BrandConstants";
import { useForm } from "react-hook-form";
import { useToaster } from "../../../_components/toaster/MuiToasterProvider";
import {
  saveNewVehicle,
  loadVehicle,
} from "../../../_redux/actions/vehicleActions";
import {
  createAppointment,
  sendAppointmentConfirmation,
} from "../../../_redux/actions/appointmentActions";
import { resetProfilePassword } from "../../../_api/usersApi";
import { enrolleeService } from "@/_services";
import {
  registerEnrollee,
  enrolleeUpdate,
  saveEnrollee,
  clientUpdate,
  loadEnrollee,
  clientProfiles,
} from "../../../_redux/actions/enrolleeActions";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import CarIcon from "../../../_images/Car_Side.svg";
import useMediaQuery from "@mui/material/useMediaQuery";
import { utilities } from "@/_helpers";
import { useNavigate } from "react-router-dom";
import ReferralModal from "../../../_components/steps/modal/ReferralModal";

const ScheduleNowStory = ({
  enrolleeUpdate,
  registerEnrollee,
  saveEnrollee,
  clientUpdate,
  saveNewVehicle,
  loadVehicle,
  loadEnrollee,
  activeStep,
  setActiveStep,
  hasSetInitialStep,
  clientProfiles,
  createAppointment,
  enrollee,
  isLoaded,
}) => {
  const [submitting, setSubmitting] = useState(false);
  // const [scheduleType, setScheduleType] = useState("Location");
  const STEPS = {
    DEVICE: "DEVICE",
    LOCATION_MAP: "LOCATION_MAP",
    LOCATION_ZIP: "LOCATION_ZIP",
    // PRICING: "PRICING",
    DATE_TIME: "DATE_TIME",
    SCHEDULE_NOW: "SCHEDULE_NOW",
  };
  const { t } = useTranslation();
  const cookies = new Cookies();
  const brand = cookies.get("lsEnrollmentReferral") || LifeSafer;
  const enrolleeUser = JSON.parse(sessionStorage.getItem("enrolleeUser"));
  const googleMapDataSession = JSON.parse(
    sessionStorage.getItem("googleMapData"),
  );
  const [pereferedContact, setPreferedContact] = useState(
    enrolleeUser?.contactPreference || "Phone",
  );

  // const [activeStep,setActiveStep]=useState(4)

  let clientSaveResponse = null;
  const enrollmentCodeData = cookies.get("lsEnrollmentCode");
  const jwtTokenData = cookies.get("lifesaferEnrollment");
  const [isEnrolleeLoadNeeded, setIsEnrolleeLoadNeeded] = useState(false);
  const toast = useToaster();
  // const deviceType = localStorage.getItem("devicetype");
  const isMountedRef = useRef(null);
  let enrolleeDataArray = useRef([]);
  const [userData, setUserData] = useState(null);
  const [isupdateprotplan, setIsupdateprotplan] = useState(false);
  // const [isSubmitAppointment, setIsSubmitAppointment] = useState(false);
  const [stepSchedule, setStepSchedule] = useState(STEPS.SCHEDULE_NOW);
  const [flagDevice, setFlagDevice] = useState(false);
  const [referralModal, setReferralModal] = useState(false);
  const [deviceLocationType, setDeviceLocationType] = useState();
  const EnrollCookieData = cookies.get("EnrollNow") || {};

  const {
    UTM_source,
    UTM_medium,
    UTM_campaign,
    GA_clientid,
    gclid,
    UserAgent,
    IPAddress,
    wbraid,
    gbraid,
    fbclid,
    fbp,
    ttclid,
    rdt_cid,
    Page: rawPage,
    URL,
  } = EnrollCookieData;
  const navigate = useNavigate();
  let shouldSkipNextStep = false;
  const setGoogleMapData = (mapData) => {
    sessionStorage.setItem("googleMapData", JSON.stringify(mapData));
  };
  const Page = rawPage?.substring(0, 150) || "";

  // useEffect(() => {
  //   if (stepSchedule === STEPS.DATE_TIME) {
  //     setScheduleType("Calendar");
  //     return;
  //   }
  //   setScheduleType("Location");
  // }, [stepSchedule]);

  let isPam =
    enrolleeUser?.clientTypeId === 5 ||
    enrolleeDataArray?.current.deviceType === "PAM" ||
    enrolleeDataArray?.current.deviceType?.toLowerCase() === "portable";

  const theme = useTheme();
  const isAbove1024 = useMediaQuery(theme.breakpoints.up(1024));
  const StyledWalkingIcon = styled(DirectionsWalkIcon)({
    fontSize: isAbove1024 ? 24 : 20,
    marginTop: 2.6,
  });

  const resolveClientDeviceType = (clientTypeId) => {
    if (clientTypeId === 5) return "Portable";
    if (clientTypeId === 6) return "Speed";
    if (clientTypeId === 1) return "Interlock";
    return null;
  };

  const resolveDeviceTypeValue = (...deviceCandidates) => {
    const explicitDeviceType = deviceCandidates.find(
      (value) => utilities?.deviceInfo(value)?.deviceType,
    );

    if (explicitDeviceType) {
      return utilities.deviceInfo(explicitDeviceType)?.deviceType || null;
    }

    return resolveClientDeviceType(enrolleeUser?.clientTypeId) || null;
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [activeStep]);

  const StyledCarIcon = styled("img")({
    // height: 28,
    height: 30,
    width: 30,
    marginTop: 8,
    filter: "invert(1)",
  });

  const handleReferalSubmit = () => {
    const storedEnrolleeUser =
      JSON.parse(sessionStorage.getItem("enrolleeUser")) || {};
    const { isReferralModalSubmit, ...cleanEnrolleeUser } = storedEnrolleeUser;

    if (isReferralModalSubmit) {
      sessionStorage.setItem(
        "enrolleeUser",
        JSON.stringify(
          utilities.normalizeEnrolleeSessionData(cleanEnrolleeUser),
        ),
      );
    }

    setReferralModal(false);
    goToNextStep();
  };

  const stepsInfo = [
    {
      name: "Welcome",
      step: 0,
      progressBarValue: 1,
      icon: null,
      title: t("steps.welcome"),
      description: t("steps.welcomeMessage1"),
    },
    {
      name: "Contact",
      step: 1,
      progressBarValue: 10,
      icon: <StyledWalkingIcon />,
      title: t("steps.aboutYou"),
      description: t("steps.aboutMessage"),
    },
    {
      name: "Violation",
      step: 2,
      progressBarValue: 35,
      icon: <StyledWalkingIcon />,
      title: t("steps.stateInformation"),
      description: t("steps.stateMessage"),
    },

    {
      name: "Address",
      step: 3,
      progressBarValue: 55,
      icon: isPam ? <StyledWalkingIcon /> : <StyledCarIcon src={CarIcon} />,
      title: t("steps.yourAddress"),
      description: t("steps.yourAddressDescription"),
    },
    {
      name: "Id",
      step: 4,
      progressBarValue: isPam ? 80 : 65,
      icon: isPam ? <StyledWalkingIcon /> : <StyledCarIcon src={CarIcon} />,
      title: t("steps.yourStateId"),
      description: t("steps.yourStateDescription"),
    },
    {
      name: "Vehicle",
      step: 5,
      progressBarValue: 75,
      icon: isPam ? <StyledWalkingIcon /> : <StyledCarIcon src={CarIcon} />,
      title: t("steps.yourVehicle"),
      description: null,
    },
    // {
    //   name: "Lpp",
    //   step: 6,
    //   progressBarValue: 95,
    //   icon: isPam ? <StyledWalkingIcon /> : <StyledCarIcon src={CarIcon} />,
    //   title: t("steps.protectionMatters"),
    //   description: null,
    // },
    {
      name: "Ready",
      step: 6,
      progressBarValue: null,
      icon: isPam ? <StyledWalkingIcon /> : <StyledCarIcon src={CarIcon} />,
      title: t("formLead.scheduleInstallation"),
      description: t("steps.scheduleInstallationDescription"),
    },
    {
      name: "Schedule",
      step: 7,
      progressBarValue: null,
      icon: isPam ? <StyledWalkingIcon /> : <StyledCarIcon src={CarIcon} />,
      title: null,
      // scheduleType === "Location"
      //   ? t("steps.selectServiceCenter")
      //   : scheduleType === "Calendar" && !isSubmitAppointment
      //     ? t("steps.selectInstallationDate")
      //     : scheduleType === "Times"
      //       ? t("steps.selectInstallationTime")
      //       : "",
      description: null,
    },
    {
      name: "MyAccount",
      step: 7,
      progressBarValue: null,
      icon: isPam ? <StyledWalkingIcon /> : <StyledCarIcon src={CarIcon} />,
      title: t("location.booked"),
      description: t("location.confirmationSent"),
    },
  ];

  const contactInfoForm = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: {
      firstName: enrolleeUser?.firstName || enrolleeUser?.FirstName || null,
      lastName: enrolleeUser?.lastName || enrolleeUser?.LastName || null,
      cellPhone: enrolleeUser?.cellPhone || enrolleeUser?.CellPhone || null,
      email: enrolleeUser?.email || enrolleeUser?.Email,
      preferedContact: null,
      call_me_out: null,
    },
  });

  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 15,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: "#eeeeee",
      ...theme.applyStyles("dark", {
        backgroundColor: "#eeeeee",
      }),
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 40,
      backgroundColor: `${brandColors[brand].secondary}`,
      ...theme.applyStyles("dark", {
        backgroundColor: `${brandColors[brand].secondary}`,
      }),
    },
  }));

  const Welcome = () => {
    return (
      <Grid sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
        <Button
          variant="contained"
          onClick={() => setActiveStep(1)}
          sx={{
            backgroundColor: `${brandColors[brand].secondary}`,
            fontWeight: "bold",
          }}
          endIcon={<VerifiedIcon />}
        >
          {t("intro.step2ButtonLabel")}
        </Button>
      </Grid>
    );
  };

  const goToBackStep = () => {
    if (activeStep > 0) {
      setActiveStep(activeStep - 1);
    }
  };

  useEffect(() => {
    isMountedRef.current = true;
    let homeLat = null;
    let homeLong = null;
    if (
      isMountedRef.current &&
      enrolleeUser?.clientId &&
      jwtTokenData?.jwtToken
    ) {
      clientProfiles(enrolleeUser?.clientId)
        .then((x) => {
          setUserData(x);
          sessionStorage.setItem("clientProfiles", JSON.stringify(x));
          if (x?.length > 0) {
            homeLat = x[0]?.homeLatitude;
            homeLong = x[0]?.homeLongitude;
          }
          const currentSessionEnrollee =
            JSON.parse(sessionStorage.getItem("enrolleeUser")) || {};
          sessionStorage.setItem(
            "enrolleeUser",
            JSON.stringify({
              ...currentSessionEnrollee,
              homeLat,
              homeLong,
            }),
          );
        })
        .catch((error) => {
          console.log(error);
        });
    }
    return () => (isMountedRef.current = false);
  }, []);

  useEffect(() => {
    isMountedRef.current = true;
    if (isMountedRef.current && enrollee !== undefined && enrollee !== null) {
      const currentSessionEnrollee =
        JSON.parse(sessionStorage.getItem("enrolleeUser")) || {};
      sessionStorage.setItem(
        "enrolleeUser",
        JSON.stringify({
          ...currentSessionEnrollee,
          ...enrollee,
          HearAboutID:
            enrollee?.HearAboutID ??
            currentSessionEnrollee?.HearAboutID ??
            null,
          HearAboutName:
            enrollee?.HearAboutName ??
            currentSessionEnrollee?.HearAboutName ??
            null,
        }),
      );
    }
    return () => (isMountedRef.current = false);
  }, [enrollee]);

  useEffect(() => {
    if (isEnrolleeLoadNeeded === true && jwtTokenData?.jwtToken) {
      const reloadEnrollee = async () => {
        const currentSessionEnrollee =
          JSON.parse(sessionStorage.getItem("enrolleeUser")) || {};
        if (
          currentSessionEnrollee?.clientId !== undefined &&
          currentSessionEnrollee?.userId !== undefined
        ) {
          try {
            const enrolleeData = await loadEnrollee(
              currentSessionEnrollee?.clientId,
              currentSessionEnrollee?.userId,
            );

            if (enrolleeData) {
              sessionStorage.setItem(
                "enrolleeUser",
                JSON.stringify({
                  ...currentSessionEnrollee,
                  ...enrolleeData,
                  HearAboutID:
                    enrolleeData?.HearAboutID ??
                    currentSessionEnrollee?.HearAboutID ??
                    null,
                  HearAboutName:
                    enrolleeData?.HearAboutName ??
                    currentSessionEnrollee?.HearAboutName ??
                    null,
                  deviceType:
                    enrolleeData?.clientTypeId === 5
                      ? "Portable"
                      : enrolleeData?.clientTypeId === 6
                        ? "Speed"
                        : "Interlock",
                }),
              );

              if (enrolleeData?.contactPreference) {
                setPreferedContact(enrolleeData?.contactPreference);
              }
            }
          } catch (error) {
            console.error(error);
          } finally {
            setIsEnrolleeLoadNeeded(false);
          }
        }
      };

      reloadEnrollee();
    }
  }, [isEnrolleeLoadNeeded]);

  useEffect(() => {
    if (!isupdateprotplan) return;

    if (enrollee?.protPlan != null) {
      const currentSessionEnrollee =
        JSON.parse(sessionStorage.getItem("enrolleeUser")) || {};
      sessionStorage.setItem(
        "enrolleeUser",
        JSON.stringify({
          ...currentSessionEnrollee,
          protPlan: enrollee?.protPlan,
        }),
      );
    }
  }, [isupdateprotplan, enrollee?.protPlan, enrolleeUser]);

  const handleUpdate = async (
    currentStep,
    updateData,
    vehicleUpdateData = updateData,
  ) => {
    if (currentStep === "Referral") {
      handleReferalSubmit();
      return;
    }
    if (updateData) {
      setSubmitting(true);
    }

    enrolleeDataArray.current = {
      ...enrolleeDataArray.current,
      ...updateData,
    };

    const currentEnrolleeUser =
      JSON.parse(sessionStorage.getItem("enrolleeUser")) || enrolleeUser || {};
    const enrolleeID =
      currentEnrolleeUser?.enrolleeId ||
      currentEnrolleeUser?.EnrolleeId ||
      enrolleeUser?.enrolleeId ||
      enrolleeUser?.EnrolleeId;
    const userId =
      currentEnrolleeUser?.userId ||
      currentEnrolleeUser?.UserId ||
      enrolleeUser?.userId ||
      enrolleeUser?.UserId;
    const clientId =
      currentEnrolleeUser?.clientId ||
      currentEnrolleeUser?.ClientId ||
      enrolleeUser?.clientId ||
      enrolleeUser?.ClientId;
    const jwtToken = jwtTokenData?.jwtToken;
    try {
      if (enrolleeID && jwtToken) {
        const enrolleData = {
          ...(currentStep === "Vehicle" ? vehicleUpdateData : updateData),
          enrolleeId: enrolleeID,
          ...(currentStep === "Vehicle" && {
            clientId,
            userId,
            enrollmentCode:
              currentEnrolleeUser?.enrollmentCode ||
              currentEnrolleeUser?.EnrollmentCode ||
              (typeof enrollmentCodeData === "string"
                ? enrollmentCodeData
                : enrollmentCodeData?.enrollmentCode ||
                  enrollmentCodeData?.EnrollmentCode),
            enrollmentCodeId:
              currentEnrolleeUser?.enrollmentCodeId ||
              currentEnrolleeUser?.EnrollmentCodeId ||
              currentEnrolleeUser?.EnrollmentCodeID ||
              enrollmentCodeData?.enrollmentCodeId ||
              enrollmentCodeData?.EnrollmentCodeId ||
              enrollmentCodeData?.EnrollmentCodeID,
          }),
          story: "Schedule Now",
          Step: currentStep,
          contactPreference: pereferedContact || "Phone",
          deviceType:
            resolveDeviceTypeValue(
              (currentStep === "Vehicle" ? vehicleUpdateData : updateData)
                ?.deviceType,
              deviceLocationType,
              enrolleeUser?.deviceType,
            ) || "Interlock",
          utM_source: UTM_source || null,
          utM_medium: UTM_medium || null,
          utM_campaign: UTM_campaign || null,
          gA_clientid: GA_clientid || null,
          gclID: gclid || null,
          userAgent: UserAgent || null,
          ipAddress: IPAddress || null,
          wbraid: wbraid || null,
          gbraid: gbraid || null,
          fbclid: fbclid || null,
          fbp: fbp || null,
          ttclid: ttclid || null,
          rdt_cid: rdt_cid || null,
          page: Page || null,
          referURL: URL?.slice(0, 500) || null,
        };
        await enrolleeUpdate(enrolleData);
      }

      if (updateData?.isReferralModalSubmit && clientId) {
        const referralSessionData =
          JSON.parse(sessionStorage.getItem("enrolleeUser")) || {};
        const preservedReferralFields = {
          HearAboutID:
            updateData?.HearAboutID ?? referralSessionData?.HearAboutID ?? null,
          HearAboutName:
            updateData?.HearAboutName ??
            referralSessionData?.HearAboutName ??
            null,
        };
        const referralClientUpdate = {
          ...referralSessionData,
          ...preservedReferralFields,
          ...updateData,
          ClientId: clientId,
          UserId: userId,
          EnrolleeId: enrolleeID,
          BrandIdentifier:
            updateData?.BrandIdentifier ||
            referralSessionData?.BrandIdentifier ||
            brand,
          CellPhone:
            updateData?.CellPhone ||
            referralSessionData?.CellPhone ||
            referralSessionData?.cellPhone ||
            null,
          HomePhone:
            updateData?.HomePhone ||
            referralSessionData?.HomePhone ||
            referralSessionData?.homePhone ||
            null,
          Email:
            updateData?.Email ||
            referralSessionData?.Email ||
            referralSessionData?.email ||
            null,
          FirstName:
            updateData?.FirstName ||
            referralSessionData?.FirstName ||
            referralSessionData?.firstName ||
            null,
          LastName:
            updateData?.LastName ||
            referralSessionData?.LastName ||
            referralSessionData?.lastName ||
            null,
          contactPreference: pereferedContact || "Phone",
          story: "Schedule Now",
        };
        await clientUpdate(referralClientUpdate);
      }

      switch (currentStep) {
        case "Contact":
          try {
            const storedContactSessionData =
              JSON.parse(sessionStorage.getItem("enrolleeUser")) || {};
            const preservedContactFields = {
              HearAboutID:
                updateData?.HearAboutID ??
                storedContactSessionData?.HearAboutID ??
                null,
              HearAboutName:
                updateData?.HearAboutName ??
                storedContactSessionData?.HearAboutName ??
                null,
            };

            if (!enrolleeID || !jwtToken) {
              const contactUpdateData = {
                ...preservedContactFields,
                ...updateData,
              };

              await registerEnrollee(contactUpdateData).then(
                async (enrolleeRes) => {
                  cookies.set(
                    "lifesaferEnrollment",
                    JSON.stringify(enrolleeRes),
                    {
                      path: "/",
                      sameSite: "strict",
                    },
                  );
                  let enrolleeData = {
                    ...contactUpdateData,
                    enrolleeId: enrolleeRes?.enrolleeId,
                    clientId: enrolleeRes?.clientId,
                    story: "Schedule Now",
                    Step: currentStep,
                    utM_source: UTM_source || null,
                    utM_medium: UTM_medium || null,
                    utM_campaign: UTM_campaign || null,
                    gA_clientid: GA_clientid || null,
                    gclID: gclid || null,
                    userAgent: UserAgent || null,
                    ipAddress: IPAddress || null,
                    wbraid: wbraid || null,
                    gbraid: gbraid || null,
                    fbclid: fbclid || null,
                    fbp: fbp || null,
                    ttclid: ttclid || null,
                    rdt_cid: rdt_cid || null,
                    page: Page || null,
                    referURL: URL?.slice(0, 500) || null,
                  };

                  if (!enrolleeRes?.jwtToken) {
                    sessionStorage.setItem(
                      "enrolleeUser",
                      JSON.stringify(
                        utilities.normalizeEnrolleeSessionData(enrolleeRes),
                      ),
                    );

                    if (["TEXT", "EMAIL"].includes(enrolleeRes?.resetSent)) {
                      shouldSkipNextStep = true;
                      return navigate("/verify", {
                        state: {
                          enrollee: enrolleeRes,
                          lifeSaferUser: contactUpdateData,
                        },
                      });
                    }

                    if (enrolleeRes?.resetSent === "CALL") {
                      shouldSkipNextStep = true;
                      return navigate("/contact-page");
                    }
                  }

                  await enrolleeUpdate(enrolleeData);
                  let clientSaveUpdateData = {
                    ...contactUpdateData,
                    UserId: enrolleeRes?.userId,
                    EnrolleeId: enrolleeRes?.enrolleeId,
                  };
                  if (
                    !utilities.isMissingOrDefaultEnrollmentCode(
                      enrollmentCodeData,
                    )
                  ) {
                    clientSaveResponse =
                      await saveEnrollee(clientSaveUpdateData);
                  }

                  let enrolleeSessionUpdateData = {
                    userId: enrolleeRes?.userId,
                    enrolleeId: enrolleeRes?.enrolleeId,
                    clientId: clientSaveResponse?.clientId,
                    Step: currentStep,
                    story: "Schedule Now",
                  };

                  enrolleeSessionUpdateData = {
                    ...enrolleeSessionUpdateData,
                    ...contactUpdateData,
                  };

                  sessionStorage.setItem(
                    "enrolleeUser",
                    JSON.stringify(
                      utilities.normalizeEnrolleeSessionData({
                        ...enrolleeSessionUpdateData,
                      }),
                    ),
                  );
                },
              );
            } else {
              const contactUpdateData = {
                ...preservedContactFields,
                ...updateData,
              };

              let clientUpdateData = {
                ...contactUpdateData,
                UserId: userId,
                EnrolleeId: enrolleeID,
                ClientId: clientId,
                Step: currentStep,
                story: "Schedule Now",
              };

              updateData = {
                ...contactUpdateData,
                UserId: userId,
                EnrolleeId: enrolleeID,
                ClientId: clientId,
                ...{ story: "Schedule Now" },
              };
              const sessionUpdateData = { ...updateData };
              delete sessionUpdateData.isReferralModalSubmit;

              sessionStorage.setItem(
                "enrolleeUser",
                JSON.stringify(
                  utilities.normalizeEnrolleeSessionData({
                    ...currentEnrolleeUser,
                    ...sessionUpdateData,
                  }),
                ),
              );

              if (clientId) {
                await clientUpdate(clientUpdateData);
              }
            }

            setReferralModal(updateData?.isReferralModalSubmit ? false : true);
          } catch (error) {
            let errMess = error.message;
            errMess = errMess.split(":").pop().replace('"', "").slice(0, -2);
            toast.error(errMess);
            return;
          }

          break;

        case "Vehicle":
          try {
            if (!updateData) {
              break;
            }
            const result = await saveNewVehicle(updateData);
            if (result) {
              const vehicleData = await loadVehicle(
                enrolleeUser?.clientId,
                enrolleeUser?.userId,
              );

              const matchedVehicle = vehicleData?.find(
                (x) => x.vehicleId === result,
              );

              if (matchedVehicle) {
                const vehicleWithoutUserId = { ...matchedVehicle };
                delete vehicleWithoutUserId.userId;
                sessionStorage.setItem(
                  "enrolleeUser",
                  JSON.stringify({
                    ...enrolleeUser,
                    ...updateData,
                    ...vehicleWithoutUserId,
                  }),
                );
              }
            }
          } catch (error) {
            let errMess = error.message;
            errMess = errMess.split(":").pop().replace('"', "").slice(0, -2);
            toast.error(errMess);
            return false;
          }
          break;

        case "Violation":
          try {
            const storedEnrolleeUser =
              JSON.parse(sessionStorage.getItem("enrolleeUser")) || {};
            const referralFields = {
              HearAboutID:
                storedEnrolleeUser?.HearAboutID ?? updateData?.HearAboutID,
              HearAboutName:
                storedEnrolleeUser?.HearAboutName ?? updateData?.HearAboutName,
            };

            if (!clientId) {
              if (
                utilities.isMissingOrDefaultEnrollmentCode(enrollmentCodeData)
              ) {
                let contactInfoFormValue = contactInfoForm.watch();
                let newContactInfoData = {
                  Step: "Violation",
                  firstName: contactInfoFormValue.firstName,
                  lastName: contactInfoFormValue.lastName,
                  homePhone: contactInfoFormValue.cellPhone,
                  email: contactInfoFormValue.email,
                  contactPreference: pereferedContact || "Phone",
                  BrandIdentifier: brand,
                  CellPhone: contactInfoFormValue.cellPhone,
                  // deviceType: deviceType || "IID",
                  EnrolleeId: enrolleeUser?.enrolleeId,
                  story: "Schedule Now",
                };

                updateData = {
                  ...updateData,
                  ...newContactInfoData,
                };
              }
              await saveEnrollee(updateData).then(async (enrolleeResponse) => {
                let newData = {
                  ...referralFields,
                  ...updateData,
                  clientId:
                    enrolleeResponse?.ClientId || enrolleeResponse?.clientId,
                  userId: enrolleeResponse?.UserId || enrolleeResponse?.userId,
                  contactPreference: pereferedContact || "Phone",
                  story: "Schedule Now",
                };

                await clientUpdate(newData);
                if (
                  utilities.isMissingOrDefaultEnrollmentCode(enrollmentCodeData)
                ) {
                  let enrolleeSessionUpdateData = {
                    userId:
                      enrolleeResponse?.userId || enrolleeResponse?.userId,
                    enrolleeId:
                      enrolleeResponse?.enrolleeId ||
                      enrolleeResponse?.EnrolleeId,
                    clientId:
                      enrolleeResponse?.clientId || enrolleeResponse?.ClientId,
                    enrollmentCode: updateData?.enrollmentCode,
                    enrollmentCodeId: updateData?.enrollmentCodeId,
                  };

                  sessionStorage.setItem(
                    "enrolleeUser",
                    JSON.stringify({
                      ...storedEnrolleeUser,
                      ...enrolleeSessionUpdateData,
                      HearAboutID:
                        referralFields?.HearAboutID ??
                        storedEnrolleeUser?.HearAboutID ??
                        null,
                      HearAboutName:
                        referralFields?.HearAboutName ??
                        storedEnrolleeUser?.HearAboutName ??
                        null,
                    }),
                  );

                  let enrolleeCodeData = {
                    enrollmentCode: updateData?.enrollmentCode,
                    enrollmentCodeId: updateData?.enrollmentCodeId,
                  };

                  const latestEnrollmentCodeData =
                    cookies.get("lsEnrollmentCode") || enrollmentCodeData || {};

                  cookies.set(
                    "lsEnrollmentCode",
                    { ...latestEnrollmentCodeData, ...enrolleeCodeData },
                    {
                      path: "/",
                      sameSite: "strict",
                    },
                  );
                }
              });
            } else {
              updateData = {
                ...referralFields,
                ...updateData,
                contactPreference: pereferedContact || "Phone",
                story: "Schedule Now",
              };

              let enrolleeCodeData = {
                enrollmentCode: updateData?.enrollmentCode,
                enrollmentCodeId: updateData?.enrollmentCodeId,
              };
              const latestEnrollmentCodeData =
                cookies.get("lsEnrollmentCode") || enrollmentCodeData || {};

              cookies.set(
                "lsEnrollmentCode",
                { ...latestEnrollmentCodeData, ...enrolleeCodeData },
                {
                  path: "/",
                  sameSite: "strict",
                },
              );
              await clientUpdate(updateData);
            }
          } catch (error) {
            let errMess = error.message;
            errMess = errMess.split(":").pop().replace('"', "").slice(0, -2);
            toast.error(errMess);
            return;
          }
          break;

        case "Id":
          updateData = {
            ...updateData,
            contactPreference: pereferedContact || "Phone",
            story: "Schedule Now",
          };
          try {
            await clientUpdate(updateData);
          } catch (error) {
            let errMess = error.message;
            errMess = errMess.split(":").pop().replace('"', "").slice(0, -2);
            toast.error(errMess);
            return;
          }

          break;

        case "Address":
          updateData = {
            ...updateData,
            contactPreference: pereferedContact || "Phone",
            story: "Schedule Now",
          };
          try {
            await clientUpdate(updateData);
          } catch (error) {
            let errMess = error.message;
            errMess = errMess.split(":").pop().replace('"', "").slice(0, -2);
            toast.error(errMess);
            return;
          }

          break;

        case "Lpp":
          updateData = {
            ...updateData,
            Step: currentStep,
            contactPreference: pereferedContact || "Phone",
            story: "Schedule Now",
          };
          try {
            await clientUpdate(updateData);
            setIsupdateprotplan(true);
          } catch (error) {
            setIsupdateprotplan(false);
            let errMess = error.message;
            errMess = errMess.split(":").pop().replace('"', "").slice(0, -2);
            toast.error(errMess);
            return;
          }
          break;
        case "Schedule":
          updateData = {
            ...updateData,
            contactPreference: pereferedContact || "Phone",
            story: "Schedule Now",
            deviceType:
              enrolleeUser?.deviceType === "Interlock" ||
              enrolleeUser?.clientTypeId === 1
                ? "IID"
                : enrolleeUser?.deviceType === "Portable" ||
                    enrolleeUser?.clientTypeId === 5
                  ? "PAM"
                  : enrolleeUser?.deviceType === "Speed" ||
                      enrolleeUser?.clientTypeId === 6
                    ? "ISA"
                    : "IID",
          };
          try {
            const newAppointment = await createAppointment(updateData);
            if (newAppointment.appointmentID > 0) {
              sessionStorage.setItem(
                "appointmentData",
                JSON.stringify({
                  ...updateData,
                  appointmentID: newAppointment.appointmentID,
                }),
              );
              const enrolleeDeviceType =
                resolveDeviceTypeValue(
                  updateData?.deviceType,
                  deviceLocationType,
                  enrolleeUser?.deviceType,
                ) || "Interlock";
              // 2. Update Enrollee Table with Complete Date & Time Stamp
              let enrolleeData = {
                ...updateData,
                enrolleeId: enrolleeID,
                clientId: clientId,
                Step: "MyAccount",
                complete: true,
                deviceType: enrolleeDeviceType,
                UTM_source: UTM_source || null,
                UTM_medium: UTM_medium || null,
                UTM_campaign: UTM_campaign || null,
                GA_clientid: GA_clientid || null,
              };
              await enrolleeUpdate(enrolleeData);
              toast.success(t("outro.apptSaveSuccess"));
            }
          } catch (error) {
            console.error("Error getting enrollment:", error);
            let errMess = error.message;
            errMess = errMess.split(":").pop().replace('"', "").slice(0, -2);
            toast.error(errMess);
            // setIsSubmitAppointment(false);
            return;
          }
          break;

        case "MyAccount":
          try {
            await resetProfilePassword(
              updateData?.userID || enrolleeUser?.userId,
              updateData?.password,
            );
            let emailObj = {
              emailAddress: enrolleeUser.email,
              brandIdentifier: brand === Monitech ? "monitechiid" : brand,
              silent: true,
            };
            enrolleeService
              .sendVerifyCode(emailObj)
              .then((message) => {
                // 1. Remove any reference to Enrollment
                cookies.remove("lifesaferEnrollment", { path: "/" });
                cookies.remove("lsEnrollmentError", { path: "/" });
                cookies.remove("lsEnrollmentCode", { path: "/" });
                cookies.remove("lifesaferRedirect", { path: "/" });
                cookies.remove("lifesaferLockout", { path: "/" });
                cookies.remove("lifesaferMailer", { path: "/" });
                cookies.remove("EnrollNow", { path: "/" });
                sessionStorage.removeItem("enrolleeUser");
                // 2. Redirect
                // window.location.replace =
                //   process.env.CP_URL +
                //   "/account/transfer/" +
                //   message +
                //   "-" +
                //   enrolleeUser.userId +
                //   "-" +
                //   enrolleeUser.clientId;
                window.location.replace(
                  process.env.CP_URL +
                    "/account/transfer/" +
                    message +
                    "-" +
                    enrolleeUser.userId +
                    "-" +
                    enrolleeUser.clientId,
                );
              })
              .catch(() => {
                console.log("Failed to retrieve auth.");
                window.location.replace(process.env.CP_URL + "/account/login");
              });
          } catch (error) {
            console.error("Error getting enrollment:", error);
            let errMess = error.message;
            errMess = errMess.split(":").pop().replace('"', "").slice(0, -2);
            toast.error(errMess);
            return;
          }
          break;

        default:
          console.warn(`Unknown step "${currentStep}"`);
      }
      hasSetInitialStep.current = true;
      if (
        !(
          currentStep === "Contact" &&
          utilities.isMissingOrDefaultEnrollmentCode(enrollmentCodeData)
        )
      ) {
        setIsEnrolleeLoadNeeded(true);
      }
      if (currentStep === "Contact") {
        if (shouldSkipNextStep) {
          return;
        }

        if (updateData?.isReferralModalSubmit) {
          goToNextStep();
        }
        return;
      }
      if (!shouldSkipNextStep) {
        goToNextStep();
      }
    } catch (error) {
      let errMess = error.message
        ?.split(":")
        .pop()
        ?.replace('"', "")
        ?.slice(0, -2);
      toast.error(t("toasts.updateFailed") + " " + errMess);
    } finally {
      setSubmitting(false);
    }
  };

  const goToNextStep = () => {
    let nextStepValue = 1;
    // if pam skip vehicle
    if (activeStep === 4 && isPam) {
      nextStepValue = 2;
    }
    setActiveStep(activeStep + nextStepValue);
  };

  const StepsHeader = ({ title, description }) => {
    if (!title && !description) return null;

    return (
      <Grid
        sx={{
          mt: 2,
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        {title ? (
          <Typography
            variant="h5"
            sx={{
              // color: `${brandColors[brand].primaryLight}`,
              color: "#4b9CD3",
              fontWeight: 600,
            }}
          >
            {title}
          </Typography>
        ) : null}
        {description ? (
          <Typography sx={{ textAlign: "center", mt: 1 }}>
            {description}
          </Typography>
        ) : null}
      </Grid>
    );
  };

  StepsHeader.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
  };

  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return <Welcome />;
      case 1:
        return (
          <>
            <Grid sx={{ display: "flex", justifyContent: "center" }}>
              <ContactInfo
                setSubmitting={setSubmitting}
                submitting={submitting}
                goToBackStep={goToBackStep}
                contactInfoForm={contactInfoForm}
                pereferedContact={pereferedContact}
                setPreferedContact={setPreferedContact}
                handleUpdate={handleUpdate}
                isLoaded={isLoaded}
              />
            </Grid>
          </>
        );
      case 2:
        return (
          <>
            <Grid sx={{ display: "flex", justifyContent: "center" }}>
              <ViolationInfo
                setSubmitting={setSubmitting}
                submitting={submitting}
                goToBackStep={goToBackStep}
                handleUpdate={handleUpdate}
              />
            </Grid>
          </>
        );
      case 3:
        return (
          <>
            <Grid sx={{ display: "flex", justifyContent: "center" }}>
              <AddressInfo
                setSubmitting={setSubmitting}
                submitting={submitting}
                goToBackStep={goToBackStep}
                handleUpdate={handleUpdate}
                userData={userData}
              />
            </Grid>
          </>
        );
      case 4:
        return (
          <>
            <Grid sx={{ display: "flex", justifyContent: "center" }}>
              <IdInfo
                setSubmitting={setSubmitting}
                submitting={submitting}
                goToBackStep={goToBackStep}
                handleUpdate={handleUpdate}
              />
            </Grid>
          </>
        );
      case 5:
        return (
          <>
            <Grid sx={{ display: "flex", justifyContent: "center" }}>
              <VehicleInfo
                setSubmitting={setSubmitting}
                submitting={submitting}
                goToBackStep={goToBackStep}
                handleUpdate={handleUpdate}
                goToNextStep={goToNextStep}
              />
            </Grid>
          </>
        );
      // case 6:
      //   return (
      //     <>
      //       <Grid sx={{ display: "flex", justifyContent: "center" }}>
      //         <LppInfo
      //           setSubmitting={setSubmitting}
      //           submitting={submitting}
      //           goToBackStep={goToBackStep}
      //           handleUpdate={handleUpdate}
      //         />
      //       </Grid>
      //     </>
      //   );
      case 6:
        return (
          <>
            <Grid sx={{ display: "flex", justifyContent: "center" }}>
              <ReadyInfo
                handleUpdate={handleUpdate}
                goToNextStep={goToNextStep}
              />
            </Grid>
          </>
        );
      case 7:
        return (
          <>
            <Grid sx={{ display: "flex", justifyContent: "center" }}>
              <LocationSchedule
                submitting={submitting}
                handleUpdate={handleUpdate}
                setActiveStep={setActiveStep}
                setDeviceLocationType={setDeviceLocationType}
                deviceLocationType={deviceLocationType}
                isLoaded={isLoaded}
                STEPS={STEPS}
                stepSchedule={stepSchedule}
                setStepSchedule={setStepSchedule}
                setGoogleMapData={setGoogleMapData}
                flagDevice={flagDevice}
                setFlagDevice={setFlagDevice}
                googleMapDataSession={googleMapDataSession}
                flagClickReset={false}
                compactScheduleFlow
                forceLocationSelectionEachEntry
              />
            </Grid>
          </>
        );
      case 8:
      case 9:
        return (
          <>
            <Grid sx={{ display: "flex", justifyContent: "center" }}>
              <MyAccount submitting={submitting} handleUpdate={handleUpdate} />
            </Grid>
          </>
        );
    }
  };

  return (
    <>
      <ReferralModal
        setReferralModal={setReferralModal}
        referralModal={referralModal}
        goToNextStep={goToNextStep}
        handleUpdate={handleUpdate}
        pereferedContact={pereferedContact}
        STEPS={STEPS}
        setStepSchedule={setStepSchedule}
        setActiveStep={setActiveStep}
        setFlagDevice={setFlagDevice}
        handleReferalSubmit={handleReferalSubmit}
      />
      {stepsInfo[activeStep] && stepsInfo[activeStep].progressBarValue && (
        <Grid sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
          <Box
            sx={{
              position: "relative",
              width: isAbove1024 ? "80%" : "100%",
              // mt: 2,
            }}
          >
            <BorderLinearProgress
              variant="determinate"
              value={stepsInfo[activeStep].progressBarValue}
              // color="success"
              sx={{ height: isAbove1024 ? "36px" : "25px", borderRadius: 10 }}
            />
            <Typography
              variant="body2"
              sx={{
                position: "absolute",
                top: "50%",
                left: {
                  // xs: `${stepsInfo[activeStep].progressBarValue - 4}%`,
                  // sm: `${stepsInfo[activeStep].progressBarValue - 1.4}%`,
                  xs: `${
                    stepsInfo[activeStep].progressBarValue - (isPam ? 4 : 6)
                  }%`, // Mobile
                  sm: `${
                    stepsInfo[activeStep].progressBarValue - (isPam ? 2.5 : 4.5)
                  }%`, // Small tablets (600px+)
                  md: `${
                    stepsInfo[activeStep].progressBarValue - (isPam ? 1.4 : 1.8)
                  }%`, // Tablets/Laptops (900px+)
                },
                transform: "translate(-50%, -50%)",
                fontWeight: "bold",
                whiteSpace: "nowrap",
                color: "white",
              }}
            >
              {stepsInfo[activeStep].icon}
            </Typography>
          </Box>
        </Grid>
      )}

      {stepsInfo[activeStep === 9 ? activeStep - 1 : activeStep] && (
        <StepsHeader
          title={
            stepsInfo[activeStep === 9 ? activeStep - 1 : activeStep].title
          }
          description={
            stepsInfo[activeStep === 9 ? activeStep - 1 : activeStep]
              .description
          }
        />
      )}

      {renderStepContent(activeStep)}
    </>
  );
};

const mapDispatchToProps = {
  registerEnrollee,
  enrolleeUpdate,
  saveEnrollee,
  clientUpdate,
  loadEnrollee,
  saveNewVehicle,
  loadVehicle,
  clientProfiles,
  createAppointment,
  sendAppointmentConfirmation,
};

ScheduleNowStory.propTypes = {
  registerEnrollee: PropTypes.func,
  enrollee: PropTypes.object.isRequired,
  enrolleeUpdate: PropTypes.func,
  saveEnrollee: PropTypes.func,
  clientUpdate: PropTypes.func,
  loadEnrollee: PropTypes.func,
  saveNewVehicle: PropTypes.func,
  loadVehicle: PropTypes.func,
  setActiveStep: PropTypes.func,
  hasSetInitialStep: PropTypes.bool,
  activeStep: PropTypes.number,
  clientProfiles: PropTypes.func,
  createAppointment: PropTypes.func,
  sendAppointmentConfirmation: PropTypes.func,
  isLoaded: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    enrollee: state.enrollee,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleNowStory);
